import { FunctionComponent } from "react";
import { Alert, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

type ManagementLoadErrorAlertProps = {
  /** i18n key for the error message body */
  messageKey: string;
  onRetry: () => void;
  testId: string;
};

/**
 * Inline load-error banner with Retry (keeps filters; re-runs the failed query).
 */
export const ManagementLoadErrorAlert: FunctionComponent<ManagementLoadErrorAlertProps> = ({
  messageKey,
  onRetry,
  testId
}) => {
  const { t } = useTranslation();

  return (
    <Alert
      severity="error"
      variant="outlined"
      role="alert"
      data-testid={testId}
      sx={{ mb: 2 }}
      action={
        <Button color="inherit" size="small" onClick={onRetry} data-testid={`${testId}-retry`}>
          {t("Try again")}
        </Button>
      }
    >
      {t(messageKey)}
    </Alert>
  );
};
